import { createStitches } from '@stitches/react'
import type * as Stitches from '@stitches/react'
import { sizes } from './sizes'
import { breakpoints } from './breakpoints'
import { colors } from './colors'
import { lin } from './lin'
import { radius } from './radius'
import { getFontStyles } from './fonts'
import { getFocusStyles } from './focusStyles'

const stitches = createStitches({
  theme: {
    colors,
    /**
     * Custom radius values
     * example:
     * 'r1': '6px',
     *  -> borderRadius: '$r1' // maps to theme.radii.1
     */
    radii: radius,
    space: sizes,
    sizes,
    zIndices: {
      header: 100,
      backdrop: 99,
      modal: 105,
      skipLink: 110,
    },
  },
  media: breakpoints,
  /**
   * Custom utilities
   * https://stitches.dev/docs/utils
   * example:
   * m: (value: string) => ({ margin: value }),
   */
  utils: {
    $mx: (value: string) => ({ marginLeft: value, marginRight: value }),
    $lin: lin,
    $projectFont: getFontStyles,
    focusStyle: getFocusStyles,
  },
})

export type CSS = Stitches.CSS<typeof stitches.config>

export const {
  styled,
  css,
  globalCss,
  keyframes,
  getCssText,
  theme,
  createTheme,
  config,
} = stitches
